import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

import Image1 from "../Images/4.jpg";
import team1 from "../Images/team1.jpg";
import team2 from "../Images/executiveBody/Adv. Ajay Bist.jpg";
import team3 from "../Images/executiveBody/Vinod Sagar (Vice President).jpg";
import team4 from "../Images/team4.jpg";
import card1 from "../Images/1.png";
import InfoCards from "../Components/Cards";
import { FaGavel } from "react-icons/fa6";
import { IoIosCall } from "react-icons/io";
import president from "../Images/executiveBody/president.png";

import { FaFacebook } from "react-icons/fa";
import { FaWhatsappSquare } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "../CSS/ImgHover.css";

const Home = () => {
  return (
    <>
      <div className="container-fluid p-md-5">
        <Row className="justify-content-center mt-4 p-sm-2 ">
          <Col md={5}>
            <hr
              style={{
                width: "3rem",
                height: "3px",
                backgroundColor: "black",
                fontWeight: "bold",
              }}
            ></hr>
            <h2>BAR ASSOCIATION DEHRADUN</h2>
            <p className="pt-2 fs-6">
              The oldest bar of Dehradun. which is a professional organization
              that represents the interests of lawyers practicing in Dehradun,
              India.
              <br></br>
              <br></br>
              It is a voluntary association of advocates, which was established
              in 2000 and has since been functioning as a platform for lawyers
              to network, share knowledge and expertise, and collectively work
              towards the betterment of the legal profession in Dehradun.
            </p>

            <Button
              href="/About"
              className="mt-3"
              size="md"
              style={{ backgroundColor: "#25477c" }}
            >
              Read More
            </Button>
          </Col>
          <Col md={6} sm={10} className="text-center">
            <img
              src={Image1}
              className="p-1 img-fluid h-100"
              style={{ borderStyle: "ridge", borderRadius: "5px" }}
            />
          </Col>
        </Row>
      </div>
      <InfoCards />
      <div>
        <Container>
          <Row className="mt-5">
            <div style={{ borderLeftStyle: "solid" }}>
              <h6>BAR ASSOCIATION</h6>
              <h2
                className="fw-bolder"
                style={{ position: "relative", zIndex: "1" }}
              >
                <FaGavel
                  style={{
                    zIndex: "-19",
                    position: "absolute",
                    opacity: ".25",
                    fontSize: "3rem",
                  }}
                />
                Meet Association Members
              </h2>
            </div>
          </Row>
          <section className="mt-5">
            <Row className="mt-md-5 mt-sm-2">
              <Col md={6} sm={12}>
                <div class="card mb-3 col-sm-12 h-100">
                  <div class="row g-0">
                    <div class="col-md-6">
                      <img
                        src={president}
                        class="img-fluid rounded-start w-100 hover-effect"
                        alt="..."
                      />
                    </div>
                    <div class="col-md-6 text-start">
                      <div class="card-body my-3">
                        <h5 class="card-title">
                          <span style={{ color: "#25477c" }}>
                            Adv. Manmohan Kandwal
                          </span>
                        </h5>
                        <p> President</p>
                        <p class="card-text">
                          Advocate Manmohan Kandwal your President ( Bar
                          Association Dehradun ) for the year 2025-26.
                        </p>
                        <p class="card-text">
                          <small class="text-muted">
                            <p>
                              <IoIosCall />
                              7533881186
                            </p>

                            <p>
                              <MdEmail /> barassociationd.dun@gmail.com
                            </p>
                          </small>
                        </p>
                        <FaFacebook className="fs-4" />
                        <FaWhatsappSquare className="fs-4 ms-4" />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div class="card mb-3 col-sm-12 h-100">
                  <div class="row g-0">
                    <div class="col-md-6">
                      <img
                        src={team2}
                        class="img-fluid rounded-start w-100 hover-effect"
                        alt="..."
                      />
                    </div>
                    <div class="col-md-6 text-start">
                      <div class="card-body my-3">
                        <h5 class="card-title">
                          <span style={{ color: "#25477c" }}>
                            Adv. Ajay Bist
                          </span>
                        </h5>
                        <p> Secretary</p>
                        <p class="card-text">
                          Advocate Ajay Bist your Secretary ( Bar Association
                          Dehradun ) for the year 2025-26.
                        </p>
                        <p class="card-text">
                          <small class="text-muted">
                            <p>
                              <IoIosCall />
                              7533881186
                            </p>

                            <p>
                              <MdEmail /> barassociationd.dun@gmail.com
                            </p>
                          </small>
                        </p>
                        <FaFacebook className="fs-4" />
                        <FaWhatsappSquare className="fs-4 ms-4" />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-md-5">
              <Col md={6} sm={12}>
                <div class="card mb-3 col-sm-12 h-100">
                  <div class="row g-0">
                    <div class="col-md-6">
                      <img
                        src={team3}
                        class="img-fluid rounded-start w-100 hover-effect"
                        alt="..."
                      />
                    </div>
                    <div class="col-md-6 text-start">
                      <div class="card-body my-3">
                        <h5 class="card-title">
                          <span style={{ color: "#25477c" }}>
                            Adv. Vinod Sagar
                          </span>
                        </h5>
                        <p> Vice President</p>
                        <p class="card-text">
                          Advocate Vinod Sagar your Vice President ( Bar
                          Association Dehradun ) for the year 2025-26.{" "}
                        </p>
                        <p class="card-text">
                          <small class="text-muted">
                            <p>
                              <IoIosCall />
                              7533881186
                            </p>

                            <p>
                              <MdEmail /> barassociationd.dun@gmail.com
                            </p>
                          </small>
                        </p>
                        <FaFacebook className="fs-4" />
                        <FaWhatsappSquare className="fs-4 ms-4" />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              {/* <Col md={6} sm={12}>
                <div class="card mb-3 col-sm-12 h-100">
                  <div class="row g-0">
                    <div class="col-md-6">
                      <img
                        src={team4}
                        class="img-fluid rounded-start w-100 hover-effect"
                        alt="..."
                      />
                    </div>
                    <div class="col-md-6 text-start">
                      <div class="card-body my-3">
                        <h5 class="card-title">
                          <span style={{ color: "#25477c" }}>
                            Adv. Anil Singh Bisht
                          </span>
                        </h5>
                        <p> Vice Secretary</p>
                        <p class="card-text">
                          Advocate Anil Singh Bist your Vice Secretary ( Bar
                          Association Dehradun ) for the year 2024-25.
                        </p>
                        <p class="card-text">
                          <small class="text-muted">
                            <p>
                              <IoIosCall />
                              7533881186
                            </p>

                            <p>
                              <MdEmail /> barassociationd.dun@gmail.com
                            </p>
                          </small>
                        </p>
                        <FaFacebook className="fs-4" />
                        <FaWhatsappSquare className="fs-4 ms-4" />
                      </div>
                    </div>
                  </div>
                </div>
              </Col> */}
            </Row>
            <Row className="mt-3">
              <Button
                className="col-md-2 col-sm-4 ms-md-3"
                size="md"
                href="/ExecutiveBody"
                style={{ backgroundColor: "#25477c" }}
              >
                View All Members
              </Button>
            </Row>
          </section>
        </Container>
      </div>
      <div className="container-fluid mt-5">
        <div class="card text-dark">
          <img
            src={Image1}
            class="card-img"
            style={{
              height: "20rem",
              width: "100%",
              objectFit: "cover",
              opacity: ".15",
            }}
            alt="..."
          />
          <div className="card-img-overlay d-flex flex-column justify-content-center text-center">
            <h3 className="card-title">We Fight for our clients</h3>
            <br />
            <h2 className="card-text">
              Just call at <span className="text-danger">7533881186</span> for
              emergency service
            </h2>
          </div>
        </div>
      </div>
      <div className="mt-5 mb-4">
        <Container>
          <Row>
            <div style={{ borderLeftStyle: "solid" }}>
              <h6>BAR ASSOCIATION</h6>
              <h2
                className="fw-bolder"
                style={{ position: "relative", zIndex: "1" }}
              >
                <FaGavel
                  style={{
                    zIndex: "-19",
                    position: "absolute",
                    opacity: ".15",
                    fontSize: "3rem",
                  }}
                />
                Library
              </h2>
            </div>
          </Row>
          <Row className="mt-3">
            <div class="row row-cols-1 row-cols-md-3 g-sm-2 g-md-4">
              <div class="col-md-4">
                <div class="card  p-4">
                  <img src={card1} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <p class="card-text">
                      It is the Library in the Doon Bar Association Dehardun. It
                      is an excellent ‘Centre for Learning’ and ‘Career
                      Counselling’.
                    </p>
                    <a
                      href="/Library"
                      class="btn btn-primary btn-sm"
                      style={{ backgroundColor: "#25477c" }}
                    >
                      View More
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card  p-3">
                  <div class="card-body">
                    <h5 class="card-title text-danger">AIMS & OBJECTIVES</h5>
                    <br />
                    <p class="card-text">
                      1. To consider matter relating to the legal profession.
                      <br />
                      2. To promote high profession of one among the members of
                      the profession.
                      <br />
                      3. To maintain and promote harmonious relating between the
                      bench and the bar.
                      <br />
                      4. To repress unprofessional practices.
                      <br />
                      5. To render the assistance to members in cases of
                      necessity.
                    </p>
                    <a
                      href="/Aims&Obj"
                      class="btn btn-primary btn-sm"
                      style={{ backgroundColor: "#25477c" }}
                    >
                      View More
                    </a>
                    <br />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card p-3">
                  <div class="card-body">
                    <h5 class="card-title text-danger">BECOME A MEMBER</h5>
                    <br />
                    <p class="card-text">
                      Download our form and submit the filled in application in
                      the DBA Office
                    </p>
                    <a
                      class="btn btn-primary btn-sm"
                      href="/Membership"
                      style={{ backgroundColor: "#25477c" }}
                    >
                      View More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Home;
